import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { HelpersService } from './../../../shared/servicio/helpers/helpers.service';
import { ComercialService } from 'src/app/shared/servicio/comercial/comercial.service';
import { AdminService } from '../../services/admin/admin.service';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

// Interfaces para tipado
interface Administrator {
  id: number;
  user: {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    role: string;
    full_name: string;
  };
  alliance: {
    id: number;
    name: string;
    laboratory: {
      id: number;
      name: string;
    };
  };
  permission_level: number;
  is_active: boolean;
  date_created: string;
}

interface Alliance {
  id: number;
  name: string;
  laboratory: {
    id: number;
    name: string;
  };
}

@Component({
  selector: 'app-create-associate',
  templateUrl: './create-associate.component.html',
  styleUrls: ['./create-associate.component.css'],
})
export class CreateAssociateComponent implements OnInit {
  @Input() modalRef: BsModalRef;
  @Input() mode: 'create' | 'edit' = 'create';
  @Input() administrator: Administrator | null = null;

  // Eventos para comunicación con el componente padre
  @Output() onCreateAdministrator = new EventEmitter<any>();
  @Output() onUpdateAdministrator = new EventEmitter<any>();

  submitted = false;
  preloader = false;
  load = true;

  cityList: any = [];
  allianceList: Alliance[] = [];
  selectedCity: any;
  selectedAlliance: Alliance | null = null;

  // Niveles de permisos disponibles
  permissionLevels = [
    { id: 1, name: 'Visualización' },
    { id: 2, name: 'Gestión de médicos' },
    { id: 3, name: 'Gestión de productos' },
    { id: 4, name: 'Gestión completa' },
    { id: 5, name: 'Super Administrador' }
  ];

  create: FormGroup;
  name: FormControl;
  name2: FormControl;
  email: FormControl;
  cell: FormControl;
  dni: FormControl;
  lastname: FormControl;
  lastname_2: FormControl;
  cityForm: FormControl;
  allianceForm: FormControl;
  permissionLevel: FormControl;
  isActive: FormControl;

  constructor(
    private formBuilder: FormBuilder,
    private _comercial: ComercialService,
    public _helper: HelpersService,
    private adminService: AdminService
  ) { }

  ngOnInit() {
    this.listCiudades();
    this.listAlliances();
    this.createForm();

    // Si estamos en modo edición, cargar los datos
    if (this.mode === 'edit' && this.administrator) {
      this.loadAdministratorData();
    }
  }

  listCiudades() {
    this._comercial.list_ciudades().subscribe(
      (data) => {
        console.log('Ciudades:', data);
        this.cityList = data;
      },
      (error) => {
        console.log('Error cargando ciudades:', error);
      }
    );
  }

  listAlliances() {
    // Usar el servicio de admin para obtener las alianzas
    this.adminService.listAlliances().subscribe(
      (data) => {
        console.log('Alianzas:', data);
        this.allianceList = data.results || data; // Manejo de paginación
      },
      (error) => {
        console.log('Error cargando alianzas:', error);
        // Si no existe el endpoint, usar datos mock
        this.allianceList = [
          {
            id: 1,
            name: 'Alianza Cardiovascular',
            laboratory: { id: 1, name: 'Laboratorio Central' }
          },
          {
            id: 2,
            name: 'Alianza Neurológica',
            laboratory: { id: 2, name: 'Laboratorio Especializado' }
          }
        ];
      }
    );
  }

  createForm() {
    console.log('Creando formulario');
    this.create = this.formBuilder.group({
      name: [
        null,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚÑñ ]*'),
        ],
      ],
      name2: [
        null,
        [
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚÑñ ]*'),
        ],
      ],
      lastname: [
        null,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚÑñ ]*'),
        ],
      ],
      lastname_2: [
        null,
        [
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚÑñ ]*'),
        ],
      ],
      cityForm: [
        null,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚÑñ ]*'),
        ],
      ],
      cell: [
        null,
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern(/^\d+$/),
        ],
      ],
      dni: [
        null,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(10),
          Validators.pattern(/^\d+$/),
        ],
      ],
      email: [null, [Validators.required, Validators.email]],
      // Nuevos campos para administradores de alianzas
      allianceForm: [null, [Validators.required]],
      permissionLevel: [3, [Validators.required, Validators.min(1), Validators.max(5)]], // 3 es un número
      isActive: [true, [Validators.required]]
    });
  }

  loadAdministratorData() {
    if (this.administrator) {
      // Cargar datos del administrador en el formulario
      this.create.patchValue({
        name: this.administrator.user.first_name,
        lastname: this.administrator.user.last_name,
        email: this.administrator.user.email,
        permissionLevel: this.administrator.permission_level,
        isActive: this.administrator.is_active
      });

      // Seleccionar la alianza
      this.selectedAlliance = this.administrator.alliance;
    }
  }

  get shortCreate() {
    return this.create.controls;
  }

  clear(id: number) {
    if (id === 1) {
      if (this.shortCreate.cityForm.value != '') {
        this.shortCreate.cityForm.setValue(null);
      }
    } else if (id === 2) {
      if (this.shortCreate.allianceForm.value != '') {
        this.shortCreate.allianceForm.setValue(null);
        this.selectedAlliance = null;
      }
    }
  }

  onSelect(event: TypeaheadMatch): void {
    this.selectedCity = event.item;
  }

  onSelectAlliance(event: TypeaheadMatch): void {
    this.selectedAlliance = event.item;
  }

  createAssociate() {
    console.log('Formulario:', this.create);
    this.preloader = true;
    this.submitted = true;

    if (this.create.valid) {
      if (this.selectedCity === undefined) {
        this.preloader = false;
        this._helper.modalError('¡Debe seleccionar una ciudad!');
        return;
      }

      if (this.selectedAlliance === null) {
        this.preloader = false;
        this._helper.modalError('¡Debe seleccionar una alianza!');
        return;
      }

      if (this.mode === 'create') {
        this.createAdministrator();
      } else {
        this.updateAdministrator();
      }
    } else {
      this.preloader = false;
      this._helper.modalError('¡Por favor complete todos los campos requeridos!');
    }
  }

  createAdministrator() {

    const permissionLevel = Number(this.shortCreate.permissionLevel.value);

    // Usar el servicio de admin para crear administradores
    this.adminService.createAllianceAdministrator(
      this.shortCreate.name.value,
      this.shortCreate.name2.value || '',
      this.shortCreate.lastname.value,
      this.shortCreate.lastname_2.value || '',
      this.shortCreate.email.value,
      this.shortCreate.cell.value,
      this.shortCreate.dni.value,
      this.selectedCity.id,
      this.selectedAlliance!.id,
      permissionLevel
    ).subscribe(
      (data) => {
        console.log('Administrador creado:', data);
        this.preloader = false;
        this.submitted = false;
        this._helper.modalSuccess('¡Nuevo administrador de alianza agregado!');

        // Emitir evento al componente padre
        this.onCreateAdministrator.emit({
          first_name: this.shortCreate.name.value,
          first_name2: this.shortCreate.name2.value || '',
          last_name: this.shortCreate.lastname.value,
          last_name2: this.shortCreate.lastname_2.value || '',
          email: this.shortCreate.email.value,
          cell: this.shortCreate.cell.value,
          dni: this.shortCreate.dni.value,
          city_id: this.selectedCity.id,
          role: 'alliance',
          alliance_id: this.selectedAlliance!.id,
          permission_level: this.shortCreate.permissionLevel.value
        });

        this.modalRef.hide();
      },
      (error) => {
        console.error('Error creando administrador:', error);
        this.preloader = false;
        this.submitted = false;
        this._helper.modalError(
          this._helper.splitErrorMessages(error.error, '<br>')
        );
      }
    );
  }

  updateAdministrator() {
    if (!this.administrator) return;
    const permissionLevel = Number(this.shortCreate.permissionLevel.value);
    // Usar el servicio de admin para actualizar administradores
    this.adminService.updateAllianceAdministrator(
      this.administrator.id,
      this.administrator.user.id,
      this.selectedAlliance!.id,
      permissionLevel,
      this.shortCreate.isActive.value
    ).subscribe(
      (data) => {
        console.log('Administrador actualizado:', data);
        this.preloader = false;
        this.submitted = false;
        this._helper.modalSuccess('¡Administrador actualizado exitosamente!');

        // Emitir evento al componente padre
        this.onUpdateAdministrator.emit({
          id: this.administrator!.id,
          user_id: this.administrator!.user.id,
          alliance_id: this.selectedAlliance!.id,
          permission_level: this.shortCreate.permissionLevel.value,
          is_active: this.shortCreate.isActive.value
        });

        this.modalRef.hide();
      },
      (error) => {
        console.error('Error actualizando administrador:', error);
        this.preloader = false;
        this.submitted = false;
        this._helper.modalError(
          this._helper.splitErrorMessages(error.error, '<br>')
        );
      }
    );
  }

  getPermissionLevelName(level: number): string {
    const permission = this.permissionLevels.find(p => p.id === level);
    return permission ? permission.name : 'Desconocido';
  }

  // Método para mantener compatibilidad con el código existente
  createComercial() {
    this.createForm();
  }
}
